// @ts-nocheck
import { v1 as uuidV1 } from 'uuid';

export class FieldsGrid {
	constructor(fields, id, content?) {
		fields.forEach((mainData) => {
			if (!mainData.fields) {
				if (mainData.type === 'FILE_UPLOAD') {
					mainData.context = uuidV1();
				}
				mainData.id = id;
				mainData.value = '';
			} else
				mainData.fields.forEach((fieldList) => {
					if (Array.isArray(fieldList))
						fieldList.forEach((fieldListByRow) => {
							if (fieldListByRow.type === 'FILE_UPLOAD') {
								fieldListByRow.context = uuidV1();
							}
							fieldListByRow.id = id;
							fieldListByRow.value = undefined;
						});
					else {
						if (fieldList.type === 'FILE_UPLOAD') {
							fieldList.context = uuidV1();
						}
						fieldList.id = id;
						fieldList.value = '';
					}
				});
		});

		this.fields = fields;
	}

	public fields;
}
